import { render, staticRenderFns } from "./StockLocationFilter.vue?vue&type=template&id=2c841639&"
import script from "./StockLocationFilter.vue?vue&type=script&lang=js&"
export * from "./StockLocationFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports